import { ProductDto, VariantDto } from "../services/generated.schemas";

export const filterOutSelectedProducts = (
  products: ProductDto[] | undefined,
  productId: string | undefined,
) => {
  return products?.filter(
    (product) => Number(product.id) !== Number(productId),
  );
};

export const destructVariantsSizes = (variants: VariantDto[] | undefined) => {
  return Array.from(
    new Set(variants?.map((variant) => variant.title.split("/")[0])),
  );
};

export const destructVariantsColors = (variants: VariantDto[] | undefined) => {
  return Array.from(
    new Set(variants?.map((variant) => variant.title.split("/")[1])),
  );
};
